module.exports = "Not Autorized"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/_common/page-not-found/page-not-found.component.html
// module id = ./src/app/sharedcomponents/_common/page-not-found/page-not-found.component.html
// module chunks = main